import React, { Component } from 'react';

export default class MissingPage extends Component {
    render() {
        return (
            <div className="missingcontent-container">
                <div className="missingcontent__image">
                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/error/error.webp"} alt={"Missing page"} className={"account__element account__picture-inner"} />
                </div>
                <div className="missingcontent__textbox text-bold">
                    This page is unavailable. 
                </div>
                <div className="missingcontent__textbox">
                    This can be due to an error or because you don't have access. Please try again later or contact us
                </div>
            </div>
        )
    }
}
